import { AuthLayout } from 'src/layouts';

export const AccountNotActivated = () => {
  return (
    <AuthLayout>
      <h1>Account Not Activated</h1>
    </AuthLayout>
  );
};
